module.exports = __webpack_public_path__ + "img/zmyslowyklub.com.9fa22961.png";